module.exports = __webpack_public_path__ + "img/footer-link-02.7fc64dc5.png";